import { APPOINTMENT_STATUS_LABELS, type AppointmentStatus } from "@shared/modules/x-atelier";
import { Badge } from "../../../core/components/ui/badge";
import { STATUS_VARIANT } from "../lib/status";

export function StatusBadge({ status }: { status: AppointmentStatus }) {
  return <Badge variant={STATUS_VARIANT[status]}>{APPOINTMENT_STATUS_LABELS[status]}</Badge>;
}

/** Version légère : un point coloré et le libellé, pour les cartes serrées (semaine). */
export function StatusDot({ status }: { status: AppointmentStatus }) {
  return (
    <span className={`status-dot status-dot--${STATUS_VARIANT[status]}`}>
      {APPOINTMENT_STATUS_LABELS[status]}
    </span>
  );
}
